import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/AppShell";
import { STATUS_LABELS, STATUS_COLORS, STATUS_ORDER } from "@/lib/format";
import { toast } from "sonner";

export default function Pipeline() {
  const [list, setList] = useState([]);
  const [drag, setDrag] = useState(null);

  const reload = () => api.get("/customers").then((r) => setList(r.data));
  useEffect(() => { reload(); }, []);

  const onDrop = async (status) => {
    if (!drag || drag.status === status) { setDrag(null); return; }
    const target = drag;
    setDrag(null);
    setList((l) => l.map((c) => c.id === target.id ? { ...c, status } : c));
    try {
      await api.patch(`/customers/${target.id}`, { ...target, status });
      toast.success(`Spostato in ${STATUS_LABELS[status]}`);
    } catch { toast.error("Errore"); reload(); }
  };

  return (
    <div data-testid="page-pipeline">
      <PageHeader eyebrow="CRM" title="Pipeline vendite" subtitle="Trascina i clienti tra le colonne" />
      <div className="px-6 py-4 overflow-x-auto scrollbar-thin">
        <div className="flex gap-3 min-w-max pb-6">
          {STATUS_ORDER.map((status) => {
            const items = list.filter((c) => c.status === status);
            return (
              <div
                key={status}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => onDrop(status)}
                className="w-72 flex-shrink-0 bg-white border border-zinc-200/70 rounded-3xl p-3 flex flex-col gap-2"
                data-testid={`column-${status}`}
              >
                <div className="flex items-center justify-between px-2 py-2 border-b border-zinc-100">
                  <div className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full" style={{ background: STATUS_COLORS[status] }} />
                    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-900">{STATUS_LABELS[status]}</div>
                  </div>
                  <span className="font-mono text-xs text-zinc-400">{items.length}</span>
                </div>
                <div className="flex flex-col gap-2 min-h-[200px]">
                  {items.length === 0 && (
                    <div className="border border-dashed border-zinc-200 rounded-2xl p-6 text-center text-zinc-400 text-xs">trascina qui</div>
                  )}
                  {items.map((c) => {
                    const name = c.business_name || `${c.first_name} ${c.last_name}`.trim();
                    return (
                      <div
                        key={c.id}
                        draggable
                        onDragStart={() => setDrag(c)}
                        className="bg-zinc-50 border border-zinc-200/70 rounded-2xl p-3 cursor-grab hover:border-zinc-300 hover:bg-white active:cursor-grabbing transition-colors"
                        data-testid={`card-${c.id}`}
                      >
                        <div className="text-sm font-semibold text-zinc-900 truncate">{name}</div>
                        <div className="text-[11px] text-zinc-400 mt-0.5">{c.city || "—"}</div>
                        <div className="mt-2 font-mono text-[10px] text-amber-600">{c.annual_consumption_kwh} kWh/anno</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
